import * as React from "react";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@/lib/utils";
import { View } from "../view";
import { CheckCircle } from "@/components/shared/icons";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
    checkCircle?: boolean;
    size?: "sm" | "md";
  }
>(({ className, checkCircle, size = "md", ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square h-4 w-4 rounded-full disabled:cursor-not-allowed disabled:opacity-50",
        checkCircle
          ? "border border-secondary-border focus:outline-primary-border"
          : "border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        "data-[state=checked]:border-none",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        {checkCircle ? (
          <CheckCircle
            weight="fill"
            size={size === "md" ? 18 : 16}
            className="shrink-0 text-primary hover:text-primary-hover"
          />
        ) : (
          <View
            className={cn(
              "aspect-square rounded-full bg-primary hover:bg-primary-hover",
              size === "md"
                ? "native:h-[10] native:w-[10] h-[9px] w-[9px]"
                : "native:h-[8] native:w-[8] h-[7px] w-[7px]",
            )}
          />
        )}
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
